import request from '@/utils/request'
import {ADMIN_URL,ADMIN_SERVICE_URL} from "@/utils/constant"
export function getDashboard(params) {
  return request({
    url: `${ADMIN_URL}/getstatistics`,
    method: 'get',
    params
  })
}
export function getAnalysis(params) {
  return request({
    url: `${ADMIN_SERVICE_URL}/statusertrip/getAnalysis`,
    method: 'get',
    params
  })
}

export function getUserRegStatistics(params) {
  return request({
    url: `${ADMIN_URL}/getregnum`,
    method: 'post',
    params
  })
}

/***
 *
 * @param params
 * @returns {AxiosPromise}
 */
export function getPayNumStatistics(params) {
  return request({
    url: `${ADMIN_URL}/getPayNum`,
    method: 'post',
    params
  })
}
